import React from "react";
import CommonTextField from "../../../components/CommonTextField";
import { UserProfileFormData } from "../hooks/useUserProfileForm";

interface UserProfileFormProps {
  formData: UserProfileFormData;

  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const UserProfileForm: React.FC<UserProfileFormProps> = ({ formData, handleChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CommonTextField label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />

      <CommonTextField label="Middle Name" name="middleName" value={formData.middleName} onChange={handleChange} />

      <CommonTextField label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange}  />

      <CommonTextField label="Date of Birth" name="dob" value={formData.dob} onChange={handleChange} disabled />

      <CommonTextField label="Email ID" name="email" type="email" value={formData.emails?.[0]?.email || ""} onChange={handleChange} required />

      <CommonTextField label="Phone Number" name="phone" value={formData.phones?.[0]?.phone || ""} onChange={handleChange} />

      <div className="md:col-span-2">
        <CommonTextField label="Address" name="addressLine1" value={formData.addressLine1} onChange={handleChange} multiline rows={2} fullWidth />
      </div>
    </div>
  );
};

export default UserProfileForm;
